export default "__VITE_ASSET__CUQLFfZj__"